import campaignService from '@/services/campaign'
import TransactionService from '@/services/transaction'

export default {
  requestPM({commit}, payload) {
    return new Promise((resolve, reject) => {
      campaignService.requestPM(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  saveDataPM({commit}, data) {
    commit('SET_SAVED_PM', data)
    return Promise.resolve(data)
  },
  getPM({commit}, params = {}) { // get list pm per campaign
    return new Promise((resolve, reject) => {
      campaignService.getPM({
        params, 
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          let datas = response.data.data,
            total = response.data.recordsTotal
          commit('SET_DATA_PM', {datas, total})
          resolve(datas)
        })
        .catch(e => reject(e))
    })
  },
  setUrgentCampaign({commit}, datas) {
    commit('SET_URGENT_CAMPAIGN', datas)
  },
  getUrgentCampaign({state}) {
    return Promise.resolve( state.urgentCampaign )
  },
  getZxCareData({commit}, payload = {}) {
    return new Promise((resolve, reject) => {
      campaignService.getData({
        params: payload.params,
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => {
        const datas = response.data.data,
            total = response.data.recordsTotal

        datas.forEach(item => item.url = `${process.env.VUE_APP_STORAGE  }/${  item.file}`)
        commit(payload.mutation, {datas, total})
        resolve(datas)
      })
    })
  },
  getData ({commit, dispatch}, payload = {}) {
    return new Promise((resolve, reject) => {
      campaignService.getData({
        params: payload.params, 
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          let datas = response.data.data,
            total = response.data.recordsTotal
          datas.forEach(item => item.url = `${process.env.VUE_APP_STORAGE  }/${  item.file}`)
          commit(payload.mutation, {datas, total})
          
          // Set urgent campaign in home
          // const urgentCampaign = datas.filter(item => item.status_priority === 1)
          // dispatch('setUrgentCampaign', urgentCampaign)

          resolve(datas)
        })
        .catch(e => reject(e))
    })
  },
  setTransactionProduct ({commit}, data) {
    commit('SET_TRANSACTION_PRODUCT', data)
    return Promise.resolve(data)
  },
  setTransactionAmount ({commit}, amount) {
    commit('SET_TRANSACTION_AMOUNT', amount)
    return Promise.resolve()
  },
  setTransactionPayment ({commit}, data) {
    commit('SET_TRANSACTION_PAYMENT', data)
  },
  getTypeTransaction ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.getTypeTransaction({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_TYPE_TRANSACTION', response.data.data)
          resolve(response.data.data)
        })
        .catch(e => reject(e))
    })
  },
  makeTransaction ({commit}, payload = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.makeTransaction(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_HISTORY_TRANSACTION', response.data)
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  urgentCampaign({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      campaignService.getData({
        params, 
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          let datas = response.data.data,
            total = response.data.recordsTotal
          datas.forEach(item => item.url = `${process.env.VUE_APP_STORAGE  }/${  item.file}`)
          commit('SET_DATA_URGENT', {datas, total})
          resolve(datas)
        })
        .catch(e => reject(e))
    })   
  },
  getDetail({state}, id) {
    let campaign = state.campaign !== null ? state.campaign.find(it => it.id == id) : null
    if(!campaign) {
      campaign = state.zxCareCampaign !== null ? state.zxCareCampaign.find(it => it.id == id) : null
    }

    if(!campaign) {
      campaign = state.searchCampaign !== null ? state.searchCampaign.find(it => it.id == id) : null
    }

    if(!campaign) {
      campaign = state.sahabatCampaign !== null ? state.sahabatCampaign.find(it => it.id == id) : null
    }
    
    if(!campaign) {
      return new Promise((resolve, reject) => {
        campaignService.getDetail({id}, {
          params:{},
          headers: {
            'Authorization': localStorage.token
          }
        })
        .then(response => {
          resolve(response.data);
          // const result = response.data.data,
          //   data = result.find(it => it.id == id)
          //   if(find) {
          //     resolve(data)
          //   }
          //   else {
          //     reject({
          //       message: 'Data not found'
          //     })
          //   }
          
          // if(!result.donatur_doa) {
          //   result.donatur_doa = []
          // }
          
          // resolve(result)
        })
        .catch(e => reject(e))
      })
    }
    else {
      return Promise.resolve(campaign)
    }
  },
  getCategory({commit}) {
    return new Promise((resolve, reject) => {
      campaignService.getCategory({
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => {
        const datas = response.data.data,
              total = response.data.recordsTotal

        commit('SET_CATEGORY_CAMPAIGN', {datas, total})
        resolve(datas)
      })
      .catch(e => reject(e))
    })
  },
  deleteTransactionProduct({commit}) {
    commit('DELETE_TRANSACTION_PRODUCT')
  },
  deleteTransactionPayment({commit}) {
    commit('DELETE_TRANSACTION_PAYMENT')
  },
  deleteTransactionAmount({commit}) {
    commit('DELETE_TRANSACTION_AMOUNT')
  },
  deleteTransactionTypes({commit}) {
    commit('DELETE_TRANSACTION_TYPES')
  },
  deleteTransactionHistory({commit}) {
    commit('DELETE_TRANSACTION_HISTORY')
  },
  removePm({commit}) {
    commit('REMOVE_DATA_PM');
  }
}